// n=8 élite (PR-N8-3) — Radar de las 21 medias de categoría (recharts).
// Un eje por categoría principal, escala 0–10, en orden de catálogo (arco
// contiguo por pilar). El polígono usa el amarillo Vertex; la pertenencia a
// cada pilar se lee por el orden + la leyenda de color que pinta el ReportView.

import {
  Radar,
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  ResponsiveContainer,
} from 'recharts';

export interface RadarAxisInput {
  label: string;
  value: number | null;
  pillar?: string;
  color?: string;
}

interface Props {
  axes: RadarAxisInput[];
  height?: number;
}

const GOLD = '#FFF200';

export default function EvaluationRadar({ axes, height = 380 }: Props) {
  const data = axes.map((a) => ({ label: a.label, value: a.value ?? 0 }));

  return (
    <div data-testid="evaluation-radar" data-axes={axes.length} style={{ width: '100%', height }}>
      <ResponsiveContainer width="100%" height="100%">
        {/* B3: margen lateral amplio + outerRadius reducido para que las 21
            etiquetas no se recorten. B2: números de escala 1-10 atenuados. */}
        <RadarChart
          data={data}
          outerRadius="62%"
          margin={{ top: 16, right: 64, bottom: 16, left: 64 }}
        >
          <PolarGrid stroke="#2A2A2A" />
          <PolarAngleAxis dataKey="label" tick={{ fill: '#B0B0B0', fontSize: 9 }} />
          <PolarRadiusAxis
            domain={[0, 10]}
            angle={90}
            tickCount={6}
            axisLine={false}
            tick={{ fill: '#4A4A4A', fontSize: 8 }}
          />
          <Radar
            dataKey="value"
            stroke={GOLD}
            fill={GOLD}
            fillOpacity={0.35}
            isAnimationActive={false}
          />
        </RadarChart>
      </ResponsiveContainer>
    </div>
  );
}
